import { useState } from "react";

import HelpCentre from "../features/helpCentre/components/HelpCentre";
import SidebarNav from "../components/sidebarNav";
import GlassPageTopBar from "../components/topBar/GlassPageTopBar";
import AppRoutes from "../routes/AppRoutes";
import AppMenuDrawer from "./components/AppMenuDrawer";

const getInitialSidebarCollapsed = () => {
    if (typeof window === "undefined") {
        return false;
    }

    return window.matchMedia("(max-width: 1023px)").matches;
};

export default function AppLayout() {
    const [sidebarCollapsed, setSidebarCollapsed] = useState(getInitialSidebarCollapsed);
    const [menuOpen, setMenuOpen] = useState(false);

    const sidebarWidthClass = sidebarCollapsed
        ? "w-[72px]"
        : "w-[180px] xl:w-[200px] 2xl:w-[260px]";

    return (
        <div className="mx-auto box-border flex min-h-screen w-full max-w-[1816px] gap-3 px-4 py-4 2xl:px-0">
            <aside
                className={`sticky top-4 z-[10] hidden h-[calc(100vh-2rem)] shrink-0 self-start overflow-visible transition-all duration-300 ease-in-out lg:block ${sidebarWidthClass}`}>
                <SidebarNav
                    collapsed={sidebarCollapsed}
                    onToggleCollapse={() => setSidebarCollapsed((prev) => !prev)}
                />
            </aside>
            <main className="relative flex min-w-0 flex-1 flex-col gap-3 pb-28">
                <GlassPageTopBar onOpenMenu={() => setMenuOpen(true)} />
                <AppMenuDrawer open={menuOpen} onClose={() => setMenuOpen(false)} />
                <div className="containher flex flex-col rounded-[1.6rem] pb-[1.6rem]">
                    <AppRoutes />
                </div>
                <HelpCentre />
            </main>
        </div>
    );
}
